import { CvTimelineStep } from 'components/cv-success';
import { getTrans } from 'modules/i18n';

/**
 * What actually happens to a submitted CV, shared by the authenticated and guest terminal
 * screens so both tell the same story.
 *
 * The steps describe the real process rather than a promised turnaround: a Zenjob operator
 * reads the CV and may polish the wording, then suggests the talent — with their CV — to the
 * partner company, which decides on an interview. No SLA is quoted anywhere, because none is
 * measured; the value here is the shape of the process, not a date.
 */
export const getCvReviewTimeline = (): CvTimelineStep[] => [
  {
    title: getTrans('cvBuilderPage.timeline.submitted.title'),
    description: getTrans('cvBuilderPage.timeline.submitted.body'),
    state: 'done'
  },
  {
    title: getTrans('cvBuilderPage.timeline.review.title'),
    description: getTrans('cvBuilderPage.timeline.review.body'),
    state: 'current'
  },
  {
    title: getTrans('cvBuilderPage.timeline.company.title'),
    description: getTrans('cvBuilderPage.timeline.company.body'),
    state: 'upcoming'
  }
];
